/* 视频详情页 */

import Vue from 'vue';
import ShareSns from '../../vue_components/share-sns.vue';
import BackTop from '../../vue_components/back-top.vue';
import PlainDialog from '../../vue_components/plain-dialog.vue';
import FeedVideoList from '../../vue_components/feed-video-list.vue'
import topHeader from '../../vue_components/common/top-header.vue'
import ArticleOrigin from '../../vue_components/ArticleOrigin.vue'

import API from '../api';
import Util from '../../utils/util.js';
import VideoPlayer from './video-player';
import questMobile from '../../utils/questMobile';
import FollowBtn from '@/vue_components/follow-btn/follow-btn.vue';
import LikeButton from '@/vue_components/article-video/like-button.vue';
import CollectionButton from '@/vue_components/collection-button.vue';
import { getUserInfo } from '../request/uisRequest';
import SlideComments from '@/vue_components/slideComments.vue';
import loadVconsole from '@/utils/vconsole';
import { bindShareClick, initWechatShare } from './handleShare';
import { addBrowseHistory } from '@/utils/browseHistory';
let useVideoTitleAb = (window.AB_TEST && window.AB_TEST.WapVdLandFoldTitle == 2) || Util.parseURL(document.location.href).isab == 1

export default function() {
    addBrowseHistory(window.cfgs?.newsId)
    // 根据环境判断加载vconsole
    loadVconsole()
    // 获取视频播放次数
    Util.initSSReadState();

    // 顶部导航
    if (document.querySelector('#topHeader')) {
        // 头部导航
        new Vue({
            el: '#topHeader',
            components: {
                topHeader
            },
        })
    }

    // 获取评论数，初始化视频
    (function getCommentCount (id) {
        $.ajax ({
            type: 'GET',
            url: `//uis.mp.sohu.com/comment/api/topics/count?source_ids=${id}`,
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            success: (res)=> {
               let commentCount = res.data[id].commentCount || 0;
               let commentLikeCount = res.data[id].commentLikeCount || 0;
               let totalCount = commentCount + commentLikeCount
               if(totalCount > 0) {
                   $('#entry-comment .count').show();
                   $('#entry-comment .count').text(Util.setCount(totalCount))
               }
               VideoPlayer({commentCount});
            },
            error: ()=> {
                VideoPlayer();
            }
        })
    })(`mp_${window.cfgs.newsId}`)

    // 订阅作者
    new Vue({
        el: '#followAuthor',
        components: {
            FollowBtn
        },
        data(){
            return {
                userInfo:null
            }
        },
        async created() {
            try {
                const res = await getUserInfo()
                this.userInfo = res.data
                this.$nextTick(() => {
                    this.$refs.refFollowBtn.initTipPage()
                })
            } catch (error) {
                console.log('初始化订阅组件报错', error)
            }
        },
        methods: {
            showFollowEntry() {
                $('.subscribe-container').show();
                    window.sohuSpm?.domDidChange({
                        target: 'followmore'
                    })
                },
            // 获取关注状态 false:未关注  true：已关注
            updateFollowStatus(status) {
                window.eventBus.$emit('updateFollowStatus', status)
            }
        },
    })
    // 绑定分享点击
    bindShareClick()
    // 点赞按钮
    new Vue({
        el: '#likeButton',
        template: '<like-button :isLogin="isLogin" :articleId="articleId"></like-button>',
        components: {
            LikeButton
        },
        data(){
            return {
                isLogin: false,
                articleId: window.cfgs?.newsId
            }
        },
        async created(){
            try {
                const res = await getUserInfo()
                res.code == 1 && ( this.isLogin = true )
            } catch (error) {
                console.log('获取登录态接口调用异常', error)
            }
        },
    })
    // 收藏按钮
    if (document.querySelector('#collectionButton')) {
        new Vue({
            el: '#collectionButton',
            components: {
                CollectionButton
            }
        })
    }
    // 外露轮播评论组件
    new Vue({
        el: "#slideComments",
        template: '<slide-comments :articleId="articleId" :accountId="accountId" :articleTitle="articleTitle"></slide-comments>',
        components:{
            SlideComments
        },
        data(){
            return {
                articleId: window.cfgs?.newsId,
                accountId: window.cfgs?.authorId,
                articleTitle: window.cfgs?.title
            }
        }
    })

    // 回到顶部
    new Vue({
        el: '#backTop',
        data() {
            return {
                loading: true,
                stat: {},
                //exposure: new Exposure() // 曝光统计
            }
        },
        components: {
            BackTop
        },
        methods: {
            registerLogin() {
                API.register("show_login", function(params, cal) {
                    let url = `https://m.passport.sohu.com/app/login?appid=116001&r=${encodeURIComponent(params.from)}`;
                    window.location.href = url;
                    if (typeof cal === 'function') cal();
                });
            },
            registerBindPhone() {
                API.register("show_bind_phone", function(params, cal) {
                    let url = `https://m.passport.sohu.com/app/quickBindPhone?appid=116001&r=${encodeURIComponent(params.from)}`;
                    window.location.href = url;
                    if (typeof cal === 'function') cal();
                })
            }
        },
        mounted() {
            this.registerLogin();
            this.registerBindPhone();
        }
    });

    // 分享弹框
    new Vue({
        el: '#shareArea',
        template: '<share-sns ref="share_dialog" :stat_data="stat_data" :need_share="need_share" :image="image" :blackList="blackList"></share-sns>',
        data() {
            return {
                stat_data: {
                    wechattimeline: '10036',
                    wechatfriends: '10037',
                    sinaweibo: '10038',
                    huyou: '10005',
                    qq: '10039',
                    qzone: '10040'
                },
                need_share: true,
                image: window.cfgs.thumbnail && window.cfgs.thumbnail.replace(/^\/\//, 'http://'),
                blackList: ['posterShare']
            }
        },
        components: {
            ShareSns
        }
    });

    // 信息提示气泡框
    new Vue({
        el : '#toastDialog',
        components : {
            PlainDialog
        }
    })

    //新的相关推荐
    if(document.querySelector("#videoFeed")){
        new Vue({
            el : '#videoFeed',
            data () {
                return {
                }
            },
            components : {
                FeedVideoList
            }
        })
    }

    // 作者声明
    if (document.querySelector('#articleOrigin')) {
        new Vue({
            el: '#articleOrigin',
            components: {
                ArticleOrigin
            },
        })
    }

    // 微信分享内容设置
    initWechatShare()

    if(document.querySelector("#foldInfo")) {
        new Vue ({
            el: '#foldInfo',
            data() {
                return {
                    show_more_text: false,
                }
            },
            computed: {

            },
            mounted() {
                if(useVideoTitleAb) {
                    $('.video-info-wrapper').addClass('no-border');
                }
            },
            methods: {
                toggleShowText() {
                    this.show_more_text = !this.show_more_text;
                    if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                        window.sohuSpm.sendAction({
                            acode: this.show_more_text ? '8898' : '8899',
                        });
                    }
                }
            }
        })
    }

    $('#entry-comment').on('click', function(){
        if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
            window.sohuSpm.sendAction({
                acode: '8882',
            });
        }
    })
    // APP增流上报请求
    questMobile()
}